
import {
  computed,
  defineComponent,
  watch,
  useStore,
} from '@nuxtjs/composition-api'
import BlockListSeoCities from '@/components/BlockListSeoCities.vue'
import SelectCityForm from '@/components/new-design/SelectCityForm.vue'
import { setCityCookie } from '@/utils/cityCookie'

export default defineComponent({
  components: { SelectCityForm, BlockListSeoCities },
  props: {},
  setup(_props) {
    const { commit, getters } = useStore()
    const isShown = computed(() => getters['popupCityList/getShownStatus'])
    const closePopup = () => {
      commit('popupCityList/SET_SHOWN', false)
    }
    const onSelectCity = (city) => {
      setCityCookie(city)
      commit('popupCityList/SET_CITY_NAME', city)
      commit('popupCityList/SET_SHOWN', false)
    }
    watch(isShown, () => {
      if (isShown.value) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').style.overflow = null
      }
    })
    return {
      onSelectCity,
      closePopup,
      isShown,
    }
  },
})
